import React, { FC } from "react";

import {
  useApisMembersKaizenIdeasLikedEmployeesIndex,
  useArray,
} from "~/hooks";

import { ReactedEmployeesModal } from "~/components/molecules";

import { ReactedEmployeeType } from "~/domains";

type PropsType = {
  kaizenIdeaId: string;
  onClose: () => void;
};

export const KaizenIdeaLikedEmployeesModal: FC<PropsType> = ({
  kaizenIdeaId,
  onClose,
}: PropsType) => {
  const { items, setItems } = useArray<ReactedEmployeeType>([]);
  const { fetchNextPage, hasNextPage, isLoading } =
    useApisMembersKaizenIdeasLikedEmployeesIndex({
      kaizenIdeaId,
      config: {
        onSuccess: (data) => {
          setItems(data.pages.map((page) => page.kaizenIdeaLikes).flat());
        },
      },
    });
  return (
    <ReactedEmployeesModal
      headerTitle="いいねしたユーザー"
      onClose={onClose}
      reactedEmployees={items}
      nextFetchFunction={fetchNextPage}
      hasMore={hasNextPage}
      isLoading={isLoading}
    />
  );
};
